











































































































import Vue from "vue";
import Component from "vue-class-component";
import { io, Socket } from "socket.io-client";
import { NotificationsApi, NotificationModel } from "../../../../apis";
import moment from "moment";

@Component({})
export default class AppNotification extends Vue {
  notificationSocket: Socket = null;
  notifications: NotificationModel[] = [];
  name = '';
  locationName = "";
  total = 0;
  page = 1;
  limit = 10;
  show = false;
  isShowProgress = false;

  created() {
    this.getNotifications(true);
    // this.getAlarm();

    this.notificationSocket = io(
      `${process.env.VUE_APP_API_URL}notification`,
      { 
        // withCredentials: true,
        transports: ['websocket', 'polling'],
      }
    );

    this.notificationSocket.on("connect", () => {
      // triggers automatically when user gets connected to the server
      // console.log(
      //   "User gets connected ... client id:",
      //   this.notificationSocket.id
      // );
    });

    this.notificationSocket.on("message", (msg) => {
      this.page = 1;
      this.getNotifications(true, true);
      // this.getAlarm();
    });
  }

  // getAlarm() {
  //   new NotificationsApi()
  //     .getAlarmNotifications({
  //       limit: 10,
  //       page: 1,
  //     })
  //     .then((resp) => {
  //       const alarms = resp.data.data;
  //       if (alarms) {
  //         this.$store.commit("SET_ALARMS", alarms);
  //       }
  //     });
  // }

  getNotification(item: NotificationModel) {
    const param = {};
    if (item.params) {
      item.params.forEach((val: { field: string; value: string }) => {
      if (val.field === "dateTime" || val.field === "maintenanceDate" )
        param[val.field] = moment
          .utc(val.value, "YYYY-MM-DD HH:mm:ss")
          .local()
          .format("DD/MM/YYYY HH:mm");
        else param[val.field] = val.value;
      });
    }
    return this.$t(`notification.type.${item.code}`, param);
  }
  handleAlarmClick(event) {
    if (event.target && event.target.classList.contains("treatment-notification")) {
      const code: string = event.target.getAttribute("code");
      if ([ "TREATMENT_START", "TREATMENT_STOP", "TREATMENT_RECOUNT", "TREATMENT_REACHED", "TREATMENT_REACHED_ALL", "TREATMENT_OUT_OF_REACH" ].includes(code)) {
        this.$router.replace({
          name: "monitoring-detail",
          params: { id: event.target.getAttribute("unitId") || "" },
          query: { t: "" + new Date().getTime() },
        });
      } else {
        this.$router.replace({
          name: "view-treatment-request",
          params: { id: event.target.getAttribute("treatmentId") },
          query: { t: "" + new Date().getTime() },
        });
      }
    }
  }
  private async getNotifications(render?: boolean, isFromSocket = false) {
    this.isShowProgress = true;
    await new NotificationsApi()
      .getNotifications({
        limit: this.limit,
        page: this.page,
        locationName: this.locationName,
      }).then((resp) => {
        if (render) {
          const dataResponse = resp.data.data;
          this.total = resp.data.count;
          if (isFromSocket) {
            this.notifications = dataResponse;
            this.isShowProgress = false;
            return;
          }
          const currentNotifies = this.notifications.map((notify) => notify);
          const removeDuplicate: NotificationModel[] = [];
          dataResponse.forEach((data) => {
            if (this.notifications.filter(notification => notification.id === data.id).length === 0) {
              removeDuplicate.push(data);
            }
          });
          this.notifications = this.removeDuplicateGlobal(currentNotifies.concat(removeDuplicate));
        }
        this.isShowProgress = false;
      }).catch(() => {
        this.isShowProgress = false;
      });
  }

  private removeDuplicateGlobal(newNotifies: NotificationModel[]) {
    const notificationAsString = newNotifies.map((notification: NotificationModel) => {
      return {
        id: notification.id,
        notificationAsString: this.getNotification(notification)
      };
    });
    let uniqueChars = [];
    let notificationIDs = [];
    const notificationAsStringReverse = notificationAsString.reverse();
    notificationAsStringReverse.forEach((element) => {
      if (!uniqueChars.includes(element.notificationAsString)) {
        notificationIDs.push(element.id);
        uniqueChars.push(element.notificationAsString);
      }
    });
    return newNotifies.filter((notification: NotificationModel) => notificationIDs.includes(notification.id));
  }

  infiniteScrolling(entries, observer, isIntersecting) {
    if (!isIntersecting) {
      return;
    }
    // setTimeout(() => {
    const el = document.querySelector(
      ".notification-menu.scale-transition-enter"
    );
    if (!el && !this.isShowProgress) {
      this.page++;
      this.getNotifications(true);
    }
    // }, 500);
  }

}
